<template>
  <div class="area_char_cla">
    <div class="bg-purple" :style="[chartCla]">
      <div class="inner">
        <h3>{{count}}</h3>

        <p>{{title}}</p>
      </div>
      <div class="icon">
        <i :class="icon"></i>
      </div>
      <div class="box-footer">
        <span @click.stop="detail" class="span_cla">
          {{detailTitle}}
          <i class="fa fa-arrow-circle-right"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'el-icon-s-tools'
    },
    detailTitle: {
      type: String,
      default: ''
    },
    chartCla: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted () {},
  methods: {
    detail () {
      this.$emit('detail')
    }
  }
}
</script>

<style scoped lang="less">
.area_char_cla {
  padding: 5px;
  box-sizing: border-box;
  background-clip: content-box;
  .bg-purple {
    border-radius: 4px;
    min-height: 36px;
    color: #fff;
    position: relative;
    background-color: red;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    .icon {
      -webkit-transition: all 0.3s linear;
      -o-transition: all 0.3s linear;
      transition: all 0.3s linear;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 0;
      font-size: 90px;
      color: rgba(0, 0, 0, 0.15);
      &:hover {
        transform: scale(1.2);
      }
    }
    .inner {
      padding: 10px;
      z-index: 50;
      h3 {
        font-size: 38px;
        font-weight: bold;
        margin: 0 0 10px 0;
        white-space: nowrap;
        padding: 0;
        z-index: 10;
      }
    }
    .box-footer {
      .span_cla {
        cursor: pointer;
        color: #fff;
        padding: 3px 10px;
        display: inline-block;
      }
      position: relative;
      text-align: center;
      color: rgba(255, 255, 255, 0.8);
      display: block;
      z-index: 10;
      background: rgba(0, 0, 0, 0.1);
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/areaChart.vue